module.exports = __webpack_public_path__ + "img/checkon.3d0941c5.svg";